/* eslint-disable no-param-reassign */
/* eslint:disable */
import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

class LHNJSSDKState {
  accessScriptError = false;

  setup: Record<string, Record<string, Record<string, string>>> = {
    denmark: {
      default: {
        application_id: '24e7ccde-838e-402d-92b6-3afeeff4e755',
        application_secret: '9df71cc009be4268a788723f24d0568c0de3a3ca2db846e09b',
      },
    },
    italy: {
      default: {
        application_id: '24e7ccde-838e-402d-92b6-3afeeff4e755',
        application_secret: '9df71cc009be4268a788723f24d0568c0de3a3ca2db846e09b',
      },
    },
    spain: {
      default: {
        application_id: '24e7ccde-838e-402d-92b6-3afeeff4e755',
        application_secret: '9df71cc009be4268a788723f24d0568c0de3a3ca2db846e09b',
      },
    },
    curacao: {
      default: {
        application_id: '24e7ccde-838e-402d-92b6-3afeeff4e755',
        application_secret: '9df71cc009be4268a788723f24d0568c0de3a3ca2db846e09b',
      },
    },
  };

  controls: Record<string, Record<string, Record<string, string>>> = {
    denmark: {
      en: {
        type: 'hoc',
        id: '175a02e8-36ef-4ea0-9f74-9586ecc70869',
      },
      default: {
        type: 'hoc',
        id: '00e2f49d-b42f-4ddb-8d2f-eb7d8a86d4b9',
      },
    },
    spain: {
      en: {
        type: 'hoc',
        id: '7c5324b1-811f-4758-ad2d-7a47dfa372d6',
      },
      default: {
        type: 'hoc',
        id: 'ce223255-7be7-4fd9-98d2-186f0c48b697',
      },
    },
    italy: {
      en: {
        type: 'hoc',
        id: '0393f585-fa0f-4797-bd78-3ff632b07313',
      },
      default: {
        type: 'hoc',
        id: 'b1475fad-1670-47e1-a7d3-fc22140877fc',
      },
    },
    curacao: {
      default: {
        type: 'hoc',
        id: 'ba1ee9d2-9bb6-4e16-88cb-ea825445b700',
      },
      su: {
        type: 'hoc',
        id: '385df6fd-e1e4-448e-8faa-edc9f14face7',
      },
      uk: {
        type: 'hoc',
        id: '8995083a-b329-4f7a-bc6d-596d2eb19235',
      },
      en: {
        type: 'hoc',
        id: 'ba3c795f-1e2b-4850-a07d-5c5fefd4b78b',
      },
      pe: {
        type: 'hoc',
        id: '997b43d0-b8f5-4f84-956e-39f756fe9ed8',
      },
      ec: {
        type: 'hoc',
        id: '52550715-9dc8-4432-a471-6976dc64be4f',
      },
      cl: {
        type: 'hoc',
        id: 'c42caaa5-a13d-4f3b-bab5-474c0ab5e2b9',
      },
      es: {
        type: 'hoc',
        id: '36c6fde0-ff12-49c1-8769-8868155c2aca',
      },
      uz: {
        type: 'hoc',
        id: '9fa77291-aceb-44a9-9f6c-41bdd486779d',
      },
      uzb: {
        type: 'hoc',
        id: 'cc4471fc-0703-4f66-9c02-b1f58aea688e',
      },
      mn: {
        type: 'hoc',
        id: '14bdd18e-0d65-48d3-84ac-86d75241f919',
      },
      br: {
        type: 'hoc',
        id: '6d96eef3-b0a9-4293-b2b2-4c668d47a1cf',
      },
      kz: {
        type: 'hoc',
        id: '385df6fd-e1e4-448e-8faa-edc9f14face7',
      },
    },
  };

  dictionary = {
    agentConnecting: 'help.LIVE_HELP_NOW_AGENT_CONNECTING',
    callbackMenu: 'help.LIVE_HELP_NOW_CALLBACK_MENU',
    callbackTitle: 'help.LIVE_HELP_NOW_CALLBACK_TITLE',
    cancel: 'help.LIVE_HELP_NOW_CANCEL',
    chatMenu: 'help.LIVE_HELP_NOW_CHAT_MENU',
    chatTitle: 'help.LIVE_HELP_NOW_CHAT_TITLE',
    email: 'help.LIVE_HELP_NOW_EMAIL',
    endChat: 'help.LIVE_HELP_NOW_END_CHAT',
    endChatConfirm: 'help.LIVE_HELP_NOW_END_CHAT_CONFIRM',
    inviteCancel: 'help.LIVE_HELP_NOW_INVITE_CANCEL',
    inviteStart: 'help.LIVE_HELP_NOW_INVITE_START',
    knowledgeMenu: 'help.LIVE_HELP_NOW_KNOWLEDGE_MENU',
    knowledgeTitle: 'help.LIVE_HELP_NOW_KNOWLEDGE_TITLE',
    livechat: 'help.LIVE_HELP_NOW_LIVE_CHAT',
    livechat_offline: 'help.LIVE_HELP_NOW_LIVE_CHAT_OFFLINE',
    newChatTitle: 'help.LIVE_HELP_NOW_NEW_CHAT_TITLE',
    offlineTitle: 'help.LIVE_HELP_NOW_OFFLINE_TITLE',
    send: 'help.LIVE_HELP_NOW_SEND',
    startChat: 'help.LIVE_HELP_NOW_START_CHAT',
    submit: 'help.LIVE_HELP_NOW_SUBMIT',
    surveyTitle: 'help.LIVE_HELP_NOW_SURVEY_TITLE',
    ticketMenu: 'help.LIVE_HELP_NOW_TICKET_MENU',
    ticketTitle: 'help.LIVE_HELP_NOW_TICKET_TITLE',
    hide: 'help.LIVE_HELP_NOW_HIDE',
    chatBoxPlaceholder: 'help.LIVE_HELP_NOW_YOUR_MESSAGE',
  };
}

class LHNJSSDKGetters extends Getters<LHNJSSDKState> {
  get isAllowed() {
    return !this.state.accessScriptError;
  }

  get dictionary(): Record<string, string> {
    return this.state.dictionary;
  }

  get controls() {
    return this.state.controls;
  }

  get setup() {
    return this.state.setup;
  }
}

class LHNJSSDKMutations extends Mutations<LHNJSSDKState> {
  updateAccessScriptError(state: boolean) {
    this.state.accessScriptError = state;
  }
}

class LHNJSSDKActions extends Actions<
  LHNJSSDKState,
  LHNJSSDKGetters,
  LHNJSSDKMutations,
  LHNJSSDKActions
  > {
}

// Экспорт модуля
export const LHNJSSDKModule = new Module({
  state: LHNJSSDKState,
  getters: LHNJSSDKGetters,
  mutations: LHNJSSDKMutations,
  actions: LHNJSSDKActions,
});

export const LHNJSSDKModuleMapper = createMapper(LHNJSSDKModule);
